module.exports = __webpack_public_path__ + "static/media/S1-35-Phroniac-Ev-cod66-B.059fbe89.png";